import { SecurityPageProps } from "models/security";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useAppDispatch } from "redux/app/hooks";
import { creditCardMask, creditCardUnmask } from "utils/mask";

import ContainerFlex from "components/ContainerFlex";
import KeyboardWrapper from "components/Keyboard";
import Input from "components/input";
import {
  addCartaoToken,
  addCartaoValidator,
  fetchValidarCartao,
  setCartao,
} from "redux/features/cartao/desbloqueio-slice";

import useApi, { ApiMethod } from "hooks/useApi";
import { cleanStateCartao } from "redux/features/cartao/cartao-slice";
import { cleanState } from "redux/features/cliente/cliente-slice";
import {
  addTypeFlowState,
  cleanStatesecurity,
} from "redux/features/security/security-slice";
import {
  resetLoading,
  setLoading,
  setTitleLoading,
} from "redux/ui/loadings-slice";
import { RouteNames } from "routes/routes";
import Endpoints from "services/api/endpoints";
import Swal from "sweetalert2";
import { ClientStatus } from "utils/clientStatus";
import { showMessage } from "utils/messages";
import { erroJaTratado } from "utils/systemError";
import {
  LOCAL_STORE_CLIENTE,
  LOCAL_STORE_ITOKEN,
  LOCAL_STORE_TOKEN_BEARER,
} from "../../../constants";
import * as St from "./styles";

const ClienteNumeroCartao: React.FC<SecurityPageProps> = () => {
  const [input, setInput] = useState("");
  const [value, setValue] = useState("");

  const keyboard = useRef(null);

  const history = useHistory();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (input.length <= 16) {
      setValue(creditCardMask(input).masked);
    }
  }, [input]);

  useEffect(() => {
    localStorage.removeItem(LOCAL_STORE_ITOKEN);
    localStorage.removeItem(LOCAL_STORE_CLIENTE);
    localStorage.removeItem(LOCAL_STORE_TOKEN_BEARER);
    sessionStorage.clear();
    dispatch(cleanState());
    dispatch(cleanStateCartao());
  }, [dispatch]);

  const RequestValidatorCard = useApi<any>(
    `${Endpoints.autorizador.validarCartao}`,
    ApiMethod.POST,
  );

  const RequestTokemCard = useApi<any>(
    `${Endpoints.autorizador.getTokenNumeroCartao}`,
    ApiMethod.POST,
    {},
    {},
    { usePublicToken: true },
  );

  const clickToBack = () => {
    history.push(RouteNames.HOME);
  };

  const handleSubmit = async () => {
    try {
      dispatch(setLoading(true));
      dispatch(setTitleLoading("Validando cartão informado, um momento..."));
      dispatch(setCartao(value));
      const responseToken = await RequestTokemCard.callApi({
        numeroCartao: creditCardUnmask(value),
      });

      if (responseToken.status >= 200 && responseToken.status < 300) {
        dispatch(addCartaoToken(responseToken.data));
        dispatch(fetchValidarCartao(responseToken.data.tokenCartao || ""));
        await localStorage.setItem("@TeuCard:itoken", responseToken.data.token);
        const response = await RequestValidatorCard.callApi({
          tokenCartao: responseToken.data.tokenCartao,
        });

        dispatch(
          setTitleLoading("Desbloqueando cartão informado, um momento..."),
        );

        if (response.status >= 200 && response.status < 300) {
          dispatch(addCartaoValidator(response.data));
          if (
            response.data.statusCliente === ClientStatus.ATIVO ||
            response.data.statusCliente === ClientStatus.INADIMPLENTE
          ) {
            Swal.fire({
              icon: "warning",
              title: "Seu cartão está Desbloqueado",
              text: "Este cartão já está Desbloqueado, Deseja iniciar o atendimento?",
              showConfirmButton: true,
              confirmButtonText: "Sim",
              confirmButtonColor: "#33A733",
              showCancelButton: true,
              cancelButtonText: "Não",
              cancelButtonColor: "#D33E3E",
              timer: 10000,
            }).then((result) => {
              if (result.value) {
                dispatch(addTypeFlowState("atendimento"));
                const propsRouter: SecurityPageProps = {
                  title: "Teu Atendimento",
                  description: `<span>Por favor, digite <span>teu CPF</span> e pressione a tecla verde (ENTRA),<br /> para continuar a operação:</span>`,
                  nextStep: RouteNames.ATENDIMENTO_HOME,
                  backStep: RouteNames.HOME,
                };

                history.push({
                  pathname: RouteNames.SECURITY_CLIENTE_CPF,
                  state: { ...propsRouter },
                });
                localStorage.removeItem(LOCAL_STORE_ITOKEN);
                localStorage.removeItem(LOCAL_STORE_CLIENTE);
                localStorage.removeItem(LOCAL_STORE_TOKEN_BEARER);
                sessionStorage.clear();
                dispatch(cleanState());
                dispatch(cleanStateCartao());
                dispatch(cleanStatesecurity());
              } else {
                history.push(RouteNames.HOME);
              }
            });
          } else if (response.data.statusCliente === ClientStatus.CANCELADO) {
            showMessage(
              "info",
              "Atenção!",
              "Seu cartão está bloqueado, procure um operador de vendas ou o SAC fone 4003-3203",
              { timer: 7000, showConfirmButton: false },
            );
            history.push(RouteNames.HOME);
          } else {
            const propsRouter: SecurityPageProps = {
              title: "Desbloqueio",
              description: `<span>Por favor, digite o teu <span>CPF</span> e pressione a tecla verde (ENTRA),<br /> para continuar a operação:</span>`,
              nextStep: RouteNames.UNLOCK_CLIENTE_DATA_NASCIMENTO,
              backStep: RouteNames.HOME,
              fluxoUnlock: true,
            };

            history.push({
              pathname: RouteNames.SECURITY_CLIENTE_CPF,
              state: { ...propsRouter },
            });
          }
        } else {
          showMessage(
            "error",
            "Atenção!",
            response.mensagem ||
              "Não foi possível validar o cartão, tente novamente mais tarde!",
            { timer: 7000, showConfirmButton: false },
          );
          history.push(RouteNames.HOME);
        }
      } else {
        // 401/403 (fora do horario funcional) ja mostra a propria mensagem, vinda do
        // handshake de token-publico (ver hooks/useApi.ts e services/api/index.ts) —
        // aqui so evita duplicar o modal.
        if (!responseToken.horarioRestritoTratado) {
          showMessage("info", "Atenção!", responseToken.data.mensagem, {
            timer: 7000,
            showConfirmButton: false,
            didClose() {
              history.push(RouteNames.HOME);
            },
          });
        } else {
          history.push(RouteNames.HOME);
        }
      }
      dispatch(resetLoading());
    } catch (error) {
      // Idem: se veio do handshake de token-publico bloqueado por 401/403 (fora do
      // horario funcional), a mensagem ja foi mostrada em services/api/index.ts.
      if (!erroJaTratado(error)) {
        showMessage(
          "error",
          "Atenção!",
          "Não foi possível validar o cartão, tente novamente mais tarde!",
          { timer: 7000, showConfirmButton: false },
        );
      }
      history.push(RouteNames.HOME);
      dispatch(resetLoading());
    }
  };

  return (
    <ContainerFlex center flex={1} horizontal>
      <ContainerFlex center>
        <St.Title>Desbloqueio</St.Title>
      </ContainerFlex>

      <ContainerFlex center>
        <St.Description>
          <span>
            Por favor, digite o <span>Número do TeuCard</span> e pressione a
            <br />
            tecla verde (ENTRA), para continuar a operação:
          </span>
        </St.Description>
      </ContainerFlex>
      <ContainerFlex center width={60}>
        <ContainerFlex marginBottom={10}>
          <Input
            label="Valor"
            style={{
              height: "15%",
              textAlign: "center",
              fontSize: "20px",
              fontWeight: "bold",
            }}
            name="valorInfo"
            value={value}
            onChange={(e) => setValue(e)}
            edit
            disabled
          />
        </ContainerFlex>
        <KeyboardWrapper
          onPressBack={clickToBack}
          keyboardRef={keyboard}
          onChange={setInput}
          typeKeyboard="numeric"
          onPressEnter={() => handleSubmit()}
        />
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default ClienteNumeroCartao;
